export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = !isDevelopment;
export const isNode = typeof process !== 'undefined' && typeof process.versions.node !== 'undefined';
